import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class ResultComponent implements OnInit {
  showError = false;
  msg = "";
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialog_param: any,
    public matDialogRef: MatDialogRef<ResultComponent>,
    private translate: TranslateService,
  ) {
    this.showError = this.dialog_param.status != "success";
    this.msg = this.dialog_param.msg
  }

  ngOnInit(): void {
  }

}
